export type MonacoEditorOptions = {
  diffView: "inline" | "side-by-side";
  wordWrap: "off" | "on";
};

export const DEFAULT_MONACO_EDITOR_OPTIONS: MonacoEditorOptions = {
  diffView: "side-by-side",
  wordWrap: "off",
};
